
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Latest News</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg ">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/gallery/diabetes-camp.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Diabetes camp, Recreation for children &amp; Swach Bharat Abhiyan</h6>
                    <a class="" href="https://drive.google.com/file/d/1jAFPRZBLoTHnbe_v8EkHSwkm4KyPp6Hp/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/cna-forum.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>CNA forum</h6>
                    <a class="" href="https://drive.google.com/file/d/1h02CXnczXjQD6PCkgo8qCjdTC3pc5u79/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div> -->
            <!-- <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/cna.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Comprehending CNA</h6>
                    <a class="" href="https://drive.google.com/file/d/13GhbTFo8OHt7CcDE8et9pfRUFcOplG2-/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/decision-making-tool.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>An Online Webinar on Decision Making Tool</h6>
                    <a class="" href="https://drive.google.com/file/d/1VfQdgdTDifnxQislRW-63pGEio3aDvJO/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div> -->
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/coffee-cup-meet-2.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Coffee Cup Meet  With Suchika Choksey & Sahil Ghai  </h6>
                    <a class="" href="https://drive.google.com/file/d/1AYOH7WhVl_OvY4eIi8qftAGFY8WHo_G3/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/open-sourse-app.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Session on Value of Open-Source Application   </h6>
                    <a class="" href="https://drive.google.com/file/d/1ZsDLzod_dLRFrf9_ccEnk7pJhfNpq-BO/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/growth-hacking.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Webinar  on Digital Marketing and Growth Hacking   </h6>
                    <a class="" href="https://drive.google.com/file/d/11w5yPOgEeaIpoUsEMkGxtwGV74avSXM6/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/workshop-teachingstaff.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>10 Days  Workshop organized for Non-Teaching Staff </h6>
                    <a class="" href="https://drive.google.com/file/d/1vYEzzQ5SjtZ2WDUMxQemAA9p7RwgQhaZ/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/coffee-cup-meet-1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>Coffee Cup Meet With Monkey Mathew  </h6>
                    <a class="" href="https://drive.google.com/file/d/1Of2wRzmAoYw00kqj-lk1r7ZEcVXySo-d/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/do-your-part.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                    <h6>A Webinar on Do your part - #Be Cyber Smart   </h6>
                    <a class="" href="https://drive.google.com/file/d/1DTBD_lv50nnC2UL7iwNTNY6rOm5Sicde/view?usp=sharing" target="_blank">View More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/youth-day.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>National Youth Day 2021</h6>
                    <a href="https://drive.google.com/file/d/1lx6IvC-ZFD8LUc5eK7wiLPBB7l1A7Z3y/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/medical-health-camp.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Medical Health Camp 2020</h6>
                    <a href="https://drive.google.com/file/d/18RFJtT6Vsu1r_9LZRA3XWqULU4Ws5iuu/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/gogreen-plantgreen.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Go green plant green 2020</h6>
                    <a href="https://drive.google.com/file/d/1SBC1HeQfbBRrLtzsyNdKaJ3cXCEM0vHL/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/gurunanak-jayanti.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Guru Nanak Jayanti 2020</h6>
                    <a href="https://drive.google.com/file/d/1K8tm4kxAuXqkLe3h0_ylbAIf5TZD8tIw/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/awareness-corona-virus.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Awareness about corona virus</h6>
                    <a href="https://drive.google.com/file/d/1lEOUDMCGXFOpN1FCfKmadiJA3kGi_m26/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/great-debate.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>The Great Debate 2020</h6>
                    <a href="https://drive.google.com/file/d/10LR9XIvVRZxemNFDn4USjmBO_ksNZx3z/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/cultural-heritage.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Culture Heritage 2020</h6>
                    <a href="https://drive.google.com/file/d/1H1vWCqVxnBe_cj0_F36FADamppX-8O1M/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/visit-to-gaushala.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Visit to Gaushala 2020</h6>
                    <a href="https://drive.google.com/file/d/1fp1avLj1BPuJ_ThqZEnw_azSqJJWfqAB/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/blankoza.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>NSS Blankoza 2020</h6>
                    <a href="https://drive.google.com/file/d/1dnnkgW2DX31YdigTD1oZSOIcriOVM9d_/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/blood-donation-2020.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Blood Donation 2020</h6>
                    <a href="https://drive.google.com/file/d/1qgg8C_1EVRAMjEnurxz-Mhxd9HD_8MoP/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/contitutional-day.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Constitution Day 2020</h6>
                    <a href="https://drive.google.com/file/d/1g8CHXUfP7TpcaUrgFWQ68quKfMExII5A/view?usp=sharing" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/np_1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Nirmalya Program</h6>
                    <a href="https://urlzs.com/frjn" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/ss_1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Surgical Strike</h6>
                    <a href="https://urlzs.com/qXco" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/bd_1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Blood Donation Camp</h6>
                    <a href="https://urlzs.com/S1NN" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/tp_1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Tree Plantation</h6>
                    <a href="https://urlzs.com/Rp6x" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/eye.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Eye & Dental  Camp</h6>
                    <a href="https://urlzs.com/NJRV" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/rotaract.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>ROTARACT Installation</h6>
                    <a href="https://urlzs.com/YZ7z" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/apti.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>STC Activity Details</h6>
                    <a data-toggle="collapse" data-target="#demo">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/storytel.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Story Telling</h6>
                    <a href="https://urlzs.com/tCct" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/Icebreaker.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Workshop on Icebreaker</h6>
                    <a href="https://urlzs.com/5Bfj" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/humorous_speech.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Humorous Speech Contest</h6>
                    <a href="https://urlzs.com/Rrpg" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/not_found.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6> Evaluation Contest Report</h6>
                    <a href="https://urlzs.com/sgaX" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/not_found.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Humorous Contest Report</h6>
                    <a href="https://urlzs.com/zo9M" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/wp_1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Waste Paper Management</h6>
                    <a href="https://urlzs.com/FJmh" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/grooming.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6> Seminar on Grooming & Attire </h6>
                    <a href="https://bit.ly/2Hc8b8e" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/GST.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Session on Introduction to GST</h6>
                    <a href="https://bit.ly/2Y7XAlk" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/GST.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6> Workshop on GST - Batch I </h6>
                    <a href="https://bit.ly/2E6VB9B" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/GST_B1.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Workshop on GST - Batch II</h6>
                    <a href="https://urlzs.com/9y4k" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/conflict.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Seminar on Conflict Management</h6>
                    <a href="https://urlzs.com/rext" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/app_wr.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Seminar on Application Writing</h6>
                    <a href="https://urlzs.com/Z7YM" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/business.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Seminar on Business in Research </h6>
                    <a href="https://urlzs.com/FLZG" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/case_study.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Workshop on Case Study</h6>
                    <a href="https://urlzs.com/EyFL" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/apti.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Aptitude Development</h6>
                    <a href="https://bit.ly/2H3KkqX" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/GST25.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Workshop on GST</h6>
                    <a href="https://urlzs.com/4ob7" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/financial.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Seminar on Financial Literacy</h6>
                    <a href="https://urlzs.com/WY3v" target="_blank">Read More</a>
                </div>
            </div>
            <div class="col-lg-3 col-6">
                <div class="latest-news" data-aos="flip-down">
                    <img src="assets/images/latest-news/corporate.webp" class="img-fluid" alt="News | Ghrcacsn" Title="News | Ghrcacsn">
                   <h6>Seminar on Corporate Culture and Social Ettiquettes</h6>
                    <a href="https://urlzs.com/3zJW" target="_blank">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>

